import Vue from 'vue'
import Router from 'vue-router'
const Full = () => import('../components/full')
const Login = () => import('../views/login')
const POS = () => import('../views/pos')
const Order = () => import('../views/order')
const page404 = () => import('../views/Error')

const Main = () => import('../views/main_page')
const Setting = () => import('../views/setting')
const MainReport = () => import('../views/main_report')
const ReportSale = () => import('../views/report_sale')
const MainStore = () => import('../views/main_store')
const UserList = () => import('../views/user_list')
const ManageUser = () => import('../views/manage_user')
const Vendor = () => import('../views/vendor')
const Customer = () => import('../views/customer')
const Calendar = () => import('../views/calendar_view')
const ItemList = () => import('../views/item_list')
const ManageItem = () => import('../views/manage_item')
const ManageCategory = () => import('../views/manage_category')
const ManageStorage = () => import('../views/manage_storage')
const ReceiveList = () => import('../views/receive_list')
const ReturnList = () => import('../views/return_list')
const ReportExpend = () => import('../views/report_expend')
const ReportCostSale = () => import('../views/report_cost_sale')
const ReportSaleItem = () => import('../views/report_sale_item')
const ReportProductMovement = () => import('../views/report_product_movement')
const ReportStock = () => import('../views/report_stock')
const ReportStockEgg = () => import('../views/report_stock_egg')
const AdjustItem = () => import('../views/adjust_item')
const TranformItem = () => import('../views/tranfrom_item')
const Reprintsale = () => import('../views/sale_bill')

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)
const titlename = ' | POS'

const router = new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  base: __dirname,
  routes: [
    {
      path: '/',
      redirect: '/',
      name: 'full',
      component: Full,
      children: [{
        path: '/',
        name: 'main',
        component: Main,
        meta: { title: 'หน้าแรก' }
      },
      {
        path: '/setting',
        name: 'setting',
        component: Setting,
        meta: { title: 'ตั้งค่าระบบ' }
      },
      {
        path: '/reports',
        name: 'main_report',
        component: MainReport,
        meta: { title: 'รายงาน' }
      },
      {
        path: '/report_sale',
        name: 'report_sale',
        component: ReportSale,
        meta: { title: 'รายงานยอดขายประจำวัน' }
      },
      {
        path: '/vendor',
        name: 'vendor',
        component: Vendor,
        meta: { title: 'จัดการข้อมูลเจ้าหนี้' }
      },
      {
        path: '/customer',
        name: 'customer',
        component: Customer,
        meta: { title: 'จัดการข้อมูลลูกหนี้' }
      },
      {
        path: '/calendar',
        name: 'calendar',
        component: Calendar,
        meta: { title: 'ปฏิทินนัดหมาย' }
      },
      {
        path: '/managestore',
        name: 'main_store',
        component: MainStore,
        meta: { title: 'รายงาน' }
      },
      {
        path: '/manageusers',
        name: 'manageusers',
        component: UserList,
        meta: { title: 'รายการผู้ใช้งาน' }
      },
      {
        path: '/editusers/:user_code',
        name: 'editusers',
        component: ManageUser,
        meta: { title: 'จัดการผู้ใช้งาน' }
      },
      {
        path: '/itemlist',
        name: 'itemlist',
        component: ItemList,
        meta: { title: 'รายการสินค้า' }
      },
      {
        path: '/manageitem/:id',
        name: 'manageitem',
        component: ManageItem,
        meta: { title: 'จัดการสินค้า' }
      },
      {
        path: '/managecategory',
        name: 'managecategory',
        component: ManageCategory,
        meta: { title: 'จัดการหมวดหมู่' }
      },
      {
        path: '/managestorage/:code',
        name: 'managestorage',
        component: ManageStorage,
        meta: { title: 'รับสินค้าเข้า' }
      },
      {
        path: '/receivelist',
        name: 'receivelist',
        component: ReceiveList,
        meta: { title: 'รายการรับเข้า' }
      },
      {
        path: '/returnlist',
        name: 'returnlist',
        component: ReturnList,
        meta: { title: 'รายการคืนสินค้า' }
      },
      {
        path: '/reportexpend',
        name: 'reportexpend',
        component: ReportExpend,
        meta: { title: 'รายงานค่าใช้จ่ายประจำวัน' }
      },
      {
        path: '/reportcostsale',
        name: 'reportcostsale',
        component: ReportCostSale,
        meta: { title: 'รายงานต้นทุนสินค้า' }
      },
      {
        path: '/reportproductmovement',
        name: 'reportproductmovement',
        component: ReportProductMovement,
        meta: { title: 'รายงานเคลื่อนไหวสินค้า' }
      },
      {
        path: '/report_saleitem',
        name: 'report_saleitem',
        component: ReportSaleItem,
        meta: { title: 'รายงานยอดขายตามสินค้า' }
      },
      {
        path: '/reportstock',
        name: 'reportstock',
        component: ReportStock,
        meta: { title: 'รายงานสินค้าคงคลัง' }
      },
      {
        path: '/reportstockegg',
        name: 'reportstockegg',
        component: ReportStockEgg,
        meta: { title: 'รายงานสินค้าไข่' }
      },
      {
        path: '/adjust_item',
        name: 'adjust_item',
        component: AdjustItem,
        meta: { title: 'รายงานต้นทุนสินค้า' }
      },
      {
        path: '/tranfrom_item',
        name: 'tranfrom_item',
        component: TranformItem,
        meta: { title: 'รายงานต้นทุนสินค้า' }
      },
      {
        path: '/reprintsale',
        name: 'reprintsale',
        component: Reprintsale,
        meta: { title: 'รายการบิลขาย' }
      }
      ]
    },
    {
      path: '/pos',
      name: 'POS',
      component: POS,
      meta: { title: 'โปรแกรมขาย' }
    },
    {
      path: '/order',
      name: 'Order',
      component: Order,
      meta: { title: 'สั่งสินค้า' }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: { title: 'เข้าสู่ระบบ' }
    },
    {
      path: '*',
      name: 'P404',
      component: page404,
      meta: { title: 'Error Page' }
    }
  ]
})

const DEFAULT_TITLE = titlename
router.afterEach((to, from) => {
  document.title = to.meta.title + titlename || DEFAULT_TITLE + titlename
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js